import React, { useState, useRef, useEffect } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPlus, faSave, faSearch, faArrowUp, faArrowDown, faCloudUpload } from '@fortawesome/free-solid-svg-icons';
import { Tooltip } from 'react-tooltip';
import 'bootstrap/dist/css/bootstrap.min.css';
import './CastingDraw.css';
import '../../Shared/Searchbar.css';
import * as XLSX from 'xlsx';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { useNavigate } from 'react-router-dom';
import CastingBedV from '../../Shared/CastingBedV';
import axios from 'axios';
import Svg from './Svg';
import Table from './Table';
import { Color } from 'three';

function CastingDraw() {
  const [filteredData, setFilteredData] = useState([]);
  const [fileName, setFileName] = useState('');
  //const fileInputRef = useRef(null);
  const navigate = useNavigate();

  const [tableVisible, setTableVisible] = useState(true);
  const [filter, setFilter] = useState('');
  const [isEditing, setIsEditing] = useState(false);
  const [color, setColor] = useState('#000000');
  const [option,setOption] =useState("t1");
  const numberOfColumns = 15; // Fixed to 15 columns
/*
* '#DDAF5B', // draft (Light teal)
'#00A2F3', // entered (Medium blue)
'#77A36F', // approved (Lime green)
'#8A8A8A', // casted (Dark gray)
'#FD9494', // in transit (Light pink)
'#A35BA3', // onsite (Dark purple)
'#E6E68A', // erected (Very light yellow)
'#EB5050', // hold (Dark red)
'#891E1E', // cancelled (Dark maroon)
'#630000', // closed (Black)*/
  const statusColors = {
    Draft: '#DDAF5B',
    Entered: '#00A2F3',
    Approved: '#77A36F',
    Casted: '#8A8A8A',
    InTransit: '#FD9494',
    OnSite: '#A35BA3',
    Erected: '#E6E68A',
    Hold: '#EB5050',
    Cancelled: '#891E1E',
    Closed: '#630000',
  };

  // ---------------- CASTING DRAW -----------------------------------
  const [selectedElementId, setSelectedElementId] = useState(null);
  const [images, setImages] = useState({
    Demo_Elem465: 'path/to/image1.png',
    Demo_Elem466: 'path/to/image2.png',
    Demo_Elem467: 'path/to/image3.png',
    // Add more mappings as needed
  });

  const handleRowClick = (elementId) => {
    setSelectedElementId(elementId);

  };

  const getImagePath = (elementId) => {
    return images[elementId] || '';
  };

  // ---------------- CASTING DRAW -----------------------------------

  useEffect(() => {


  }, []);


  const handleFileUpload = (e) => {
    const file = e.target.files[0];
    const reader = new FileReader();

  };



  const handleFilterChange = (e) => {
    setFilter(e.target.value);
  };



  const toggleTableVisibility = () => {
    setTableVisible(!tableVisible);
  };


  const handleInputBlur = () => {
    setIsEditing(false);
  };



  function processData(data) {
    // Example processing logic, adjust as necessary
    return data; // Directly return the data if no processing is needed
  }



    const staticRows = [
      ['Status','Part', 'Element ID', 'Description', 'Project', 'WBS Phase', 'Volume', 'Area', 'Height', 'Weight'],
      ['Approved','SWP', 'EW01-1', 'PRECAST CONCRETE SWP', '23011SM006', 'Production', '1.0000', '0.0000', '143.2500', '9713.0000'],
      ['Approved','SWP', 'EW01-2', 'PRECAST CONCRETE SWP', '23011SM006', 'Production', '1.0000', '0.0000', '143.2500', '9713.0000'],
      ['Entered','SWP', 'EW01-3', 'PRECAST CONCRETE SWP', '23011SM006', 'Production', '1.0000', '0.0000', '143.2500', '9713.0000'],
      ['Entered','SWP', 'EW02', 'PRECAST CONCRETE SWP', '23011SM006', 'Production', '1.0000', '0.0000', '143.2500', '9713.0000'],
      ['Casted','SWP', 'CL04', 'PRECAST CONCRETE SWP', '23011SM006', 'Production', '1.0000', '0.0000', '171.2500', '5061.0000'],
      ['OnSite','SWP', 'CR03', 'PRECAST CONCRETE SWP', '23011SM006', 'Production', '1.0000', '0.0000', '171.2500', '5061.0000'],
      ['Casted','SWP', 'CL01', 'PRECAST CONCRETE SWP', '23011SM006', 'Production', '1.0000', '0.0000', '143.2500', '6374.0000'],
      ['Entered','SWP', 'CL03', 'PRECAST CONCRETE SWP', '23011SM006', 'Production', '1.0000', '0.0000', '143.2500', '7344.0000'],
      ['Entered','SWP', 'CR02', 'PRECAST CONCRETE SWP', '23011SM006', 'Production', '1.0000', '0.0000', '143.2500', '8383.0000'],
      ['Casted','SWP', 'CR04', 'PRECAST CONCRETE SWP', '23011SM006', 'Production', '1.0000', '0.0000', '3.6000', '15.600'],
      ['Erected','SWP', 'CL02', 'PRECAST CONCRETE SWP', '23011SM006', 'Production', '1.0000', '0.0000', '189.2500', '10472.0000'],
      ['Entered','SWP', 'CR01', 'PRECAST CONCRETE SWP', '23011SM006', 'Production', '1.0000', '0.0000', '189.2500', '10472.0000'],
      ['Entered','SWP', 'EL01', 'PRECAST CONCRETE SWP', '23011SM006', 'Production', '1.0000', '0.0000', '143.0000', '4049.0000'],
    ];

  let Table1 = [{
    Name: 'EW01-1',
    Color: 'Approved',
  },
{

    Name: 'EW01-2',
    Color: 'Approved',

}
,
{

    Name: 'EW01-3',
    Color: 'Entered',
},
{
 Name: 'EW02',
    Color: 'Entered',
}
,{
  Name: 'CL04',
  Color: 'Casted',
},
{
  Name: 'CR03',
  Color: 'OnSite',
},
{
  Name:" ",
  Color:""
}
]
let Table2 = [{
  Name: 'CL01',
  Color: 'Casted',
},
{
  Name: 'CL03',
  Color: 'Entered',
},
{
  Name: 'CR02',
  Color: 'Entered',
},
{
  Name: 'CR04',
  Color: 'Casted',
},
{
  Name: 'CL02',
  Color: 'Erected',
},
{
  Name: 'CR01',
  Color: 'Entered',
},
{
  Name: 'EL01',
  Color: 'Entered',
},
];
  return (
    <div>

    <div className='card hollowtable'>
      <ToastContainer />
      <div className='card-header'>
        <div className='ctrl-btns-holloSWPand'>
          <Tooltip anchorSelect='#upload' content='Load File' place='bottom' />
          <button className='btn' id='add' >
            <FontAwesomeIcon icon={faPlus} />
          </button>
          <Tooltip anchorSelect='#add' content='Add' place='bottom' />
          <button className='btn' id='save' >
            <FontAwesomeIcon icon={faSave} />
          </button>
          <Tooltip anchorSelect='#save' content='Save' place='bottom' />
        </div>
      </div>
      {tableVisible && (
        <>
          <div className='card-body'>
            <div className='table-responsive'>
              <div className='scrollable-table-body table-bordered'>
                <table className='table table-bordered-hollow'>
                  <thead className='table-primary'>
                    <tr className='bg-primary text-white'>
                      <th>Status</th>
                      <th>Part</th>
                      <th>Element ID</th>
                      <th>Description</th>
                      <th>Project</th>
                      <th>WBS Phase</th>
                      <th>Volume</th>
                      <th>Area</th>
                      <th>Height</th>
                      <th>Weight</th>
                    </tr>
                  </thead>
                  <tbody>
                    {staticRows.slice(1).map((row, rowIndex) => (
                      <tr
                        key={rowIndex}
                        onClick={() => {handleRowClick(row[2]);
                        setColor(statusColors[row[0]]);
                        }}
                        // onMouseOver={() => setSelectedElementId(row[1])}
                        // onMouseOut={() => setSelectedElementId(null)}
                      >
                        {row.map((cell, cellIndex) => (
                          <td key={cellIndex}>
                            {cell}
                          </td>
                        ))}
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            </div>
          </div>
                    {/*  */}
        {/* Image display area */}

        <div className='card-body image-display px-5'>

            {selectedElementId && (
              <>
              <h1>Current Element </h1>
              <div className='H-h-100 w-100 bg-light d-flex align-middle justify-content-center'>
                <div className='h-25 w-25'>
       <Svg drawing={selectedElementId} Color={color} />
       </div>
       </div>
       </>
            )}
          </div>
          <div className='card hollowtable'>
        <div className='card-header'>
        <h1>Table View</h1>
        </div>
        <div className='card-body'>
        <div className="container">
            <select className="DropdownTable" onChange={(e)=>{
              console.log(e.target.value);
              setOption(e.target.value)}}>
                <option value="t1" >Table 1</option>
                <option value="t2" >Table 2</option>
                <option value="both">Both</option>
            </select>
            </div>
            <div className='card-body image-display  '>
          <h1>Table Visualization</h1>

          <div className='H-h-100 bg-light d-flex p-5 align-middle justify-content-around '>

          <Table table1={Table1} table2={Table2} colorMap={statusColors} show={option} />
          </div>
       </div>
        </div>
      </div>
          {/* <div className='card-body image-display  '>
          <h1>Table Visualization</h1>

          <div className='H-h-100 bg-light d-flex p-5 align-middle justify-content-around '>

          <Table table1={Table1} table2={Table2} colorMap={statusColors} show={"both"} />
          </div>
       </div> */}
        </>
      )}


    </div>
    </div>
  );
}

export default CastingDraw;
